/**
 * Gets platform information without using deprecated navigator.platform
 */
const getPlatformInfo = (): string => {
  // Use userAgentData if available (modern browsers)
  if ('userAgentData' in navigator && (navigator as any).userAgentData?.platform) {
    return (navigator as any).userAgentData.platform;
  }

  // Fallback: parse from user agent
  const ua = navigator.userAgent;
  if (ua.includes('Win')) return 'Windows';
  if (ua.includes('Mac')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  if (ua.includes('Android')) return 'Android';
  if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';

  return 'Unknown';
};

/**
 * Generates a device fingerprint based on browser and system information
 * This creates a semi-unique identifier for the device without storing cookies
 */
export const generateDeviceFingerprint = (): string => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  let canvasFingerprint = '';

  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device Fingerprint', 2, 2);
    canvasFingerprint = canvas.toDataURL().slice(-50);
  }

  const platformInfo = getPlatformInfo();

  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    screen.width,
    screen.height,
    new Date().getTimezoneOffset(),
    canvasFingerprint,
    navigator.hardwareConcurrency || 0,
    platformInfo
  ].join('|');

  console.log('🔍 Device fingerprint components:', {
    userAgent: navigator.userAgent,
    language: navigator.language,
    colorDepth: screen.colorDepth,
    screenWidth: screen.width,
    screenHeight: screen.height,
    timezoneOffset: new Date().getTimezoneOffset(),
    canvasFingerprintLength: canvasFingerprint.length,
    hardwareConcurrency: navigator.hardwareConcurrency || 0,
    platform: platformInfo,
    rawFingerprint: fingerprint
  });

  // Create a simple hash of the fingerprint
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  const result = Math.abs(hash).toString(36);
  console.log('🔍 Final fingerprint hash:', result);

  return result;
};

/**
 * Gets detailed device information for display purposes
 */
export const getDeviceInfo = () => {
  const ua = navigator.userAgent;

  let browser = 'Unknown';
  if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';
  else if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Edge')) browser = 'Edge';

  let os = 'Unknown';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iOS')) os = 'iOS';

  return {
    browser,
    os,
    platform: getPlatformInfo()
  };
};
